import { motion } from 'framer-motion'
import { Facebook, Instagram, Twitter, Linkedin, Youtube, Globe } from 'lucide-react'
import { useStore } from '../../store/useStore'

const SocialButtons = ({ className = "" }) => {
  const { socialMediaLinks } = useStore()

  const platforms = {
    facebook: { icon: Facebook, color: 'bg-blue-600 hover:bg-blue-700' },
    instagram: { icon: Instagram, color: 'bg-pink-600 hover:bg-pink-700' },
    twitter: { icon: Twitter, color: 'bg-blue-400 hover:bg-blue-500' },
    linkedin: { icon: Linkedin, color: 'bg-blue-700 hover:bg-blue-800' },
    youtube: { icon: Youtube, color: 'bg-red-600 hover:bg-red-700' },
    website: { icon: Globe, color: 'bg-gray-600 hover:bg-gray-700' }
  }

  const activeLinks = socialMediaLinks.filter(link => link.isActive)

  // Toujours afficher quelque chose, même si aucun réseau n'est configuré
  if (activeLinks.length === 0) {
    return (
      <div className={`flex items-center space-x-3 ${className}`}>
        <p className="text-white/70 text-sm">Configurez vos réseaux sociaux dans les paramètres</p>
      </div>
    )
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {activeLinks.map((link, index) => {
        const platform = platforms[link.platform]
        if (!platform) return null

        const Icon = platform.icon
        
        return (
          <motion.a
            key={link.platform}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`p-3 rounded-full ${platform.color} text-white transition-all duration-300 hover:scale-110 hover:shadow-lg`}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            title={`Visiter notre ${link.platform}`}
          >
            <Icon size={20} />
          </motion.a>
        )
      })}
    </div>
  )
}

export default SocialButtons
